import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { X, Plus, Minus } from 'lucide-react';

const CartItemRow = memo(({ item, onUpdateQty, onRemove, sectionColor, minMoq, isUpdating }) => {
  // Resolve image URL
  const imageUrl = item.image || item.imageUrl || '/placeholder_product.png';

  const isSet = item.moqType === 'set';
  const unitsPerSet = item.unitsPerSet || 1;
  const limitMoq = isSet ? (minMoq || 1) * unitsPerSet : (minMoq || 1);
  const isMinQty = item.qty <= limitMoq;
  const step = isSet ? unitsPerSet : 1;
  const setCount = item.qty / unitsPerSet;

  const handleQtyChange = (delta) => {
    const newQty = item.qty + delta;
    if (newQty >= limitMoq) {
      onUpdateQty(item, newQty);
    }
  };

  const itemTotal = item.price * item.qty;

  const accentStyle = {
    '--section-color': sectionColor || '#ff6a00'
  };

  return (
    <tr className="cart-item-row" style={accentStyle}>
      <td className="col-product">
        <div className="product-info-cell">
          <Link to={`/product/${item.productId}`} className="product-cell-image-link" aria-label={`View details for ${item.name}`}>
            <img src={imageUrl} alt={item.name} className="product-cell-image" />
          </Link>
          <div className="product-cell-details">
            <h4 className="product-cell-name">{item.name}</h4>
            <span className="product-cell-meta">{item.category || 'General'}</span>
          </div>
        </div>
      </td>
      <td className="col-price">
        <span className="price-cell-value">₹{item.price.toLocaleString('en-IN')}</span>
        <span className="price-cell-unit"> / Pc</span>
      </td>
      <td className="col-quantity">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div className="qty-picker">
            <button 
              type="button" 
              onClick={() => handleQtyChange(-step)} 
              disabled={isMinQty || isUpdating}
              className="qty-picker-btn btn-dec"
              aria-label="Decrease quantity"
              style={{ 
                cursor: (isMinQty || isUpdating) ? 'not-allowed' : 'pointer', 
                opacity: isMinQty ? 0.35 : (isUpdating ? 0.5 : 1) 
              }}
            >
              <Minus size={14} />
            </button>
            <span className="qty-picker-value">{item.qty}</span>
            <button 
              type="button" 
              onClick={() => handleQtyChange(step)} 
              disabled={isUpdating}
              className="qty-picker-btn btn-inc"
              aria-label="Increase quantity"
              style={{ 
                cursor: isUpdating ? 'not-allowed' : 'pointer', 
                opacity: isUpdating ? 0.5 : 1 
              }}
            >
              <Plus size={14} />
            </button>
            <span className="qty-picker-unit">Pcs</span>
          </div>
          {isSet && (
            <span className="qty-set-info" style={{ fontSize: '0.75rem', color: 'var(--color-text-secondary)', marginTop: '4px', fontWeight: '500' }}>
              {setCount} Set{setCount === 1 ? '' : 's'} × {unitsPerSet} Pcs
            </span>
          )}
        </div>
      </td>
      <td className="col-total">
        <span className="total-cell-value">
          ₹{itemTotal.toLocaleString('en-IN')}
        </span>
      </td>
      <td className="col-remove">
        <button 
          type="button" 
          onClick={() => onRemove(item.productId)} 
          disabled={isUpdating}
          className="row-remove-btn"
          title="Remove from cart"
          style={{ 
            cursor: isUpdating ? 'not-allowed' : 'pointer', 
            opacity: isUpdating ? 0.5 : 1 
          }}
        >
          <X size={16} />
        </button>
      </td>
    </tr>
  );
});

export default CartItemRow;
